import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  text: React.ReactNode;
  htmlFor?: string;
  required?: boolean;
  optional?: boolean;
  id?: string;
  labelHelperText?: string;
  className?: string;
};

const Label = ({
  text,
  htmlFor,
  required,
  optional,
  id,
  labelHelperText,
  className,
}: Props) => {
  const { t } = useTranslation();

  return (
    <label
      className={classNames(
        'text-base font-medium text-light-text-primary dark:text-dark-text-primary mb-2 flex justify-between items-center',
        className
      )}
      htmlFor={htmlFor}
      id={id}
    >
      <span className="flex gap-2">
        <div>{text}</div>
        {/* {required && (
          <span className="text-red-500 font-normal">
            *
          </span>
        )} */}
        {optional && (
          <span className="text-light-text-placeholder dark:text-dark-text-placeholder font-normal">
            {' '}
            {t('optional')}{' '}
          </span>
        )}
      </span>
      <span className="text-text-secondary text-sm font-normal">
        {labelHelperText}
      </span>
    </label>
  );
};

export default Label;
